import { render, staticRenderFns } from "./PaywallSubscriptionNotice.vue?vue&type=template&id=2c518246&scoped=true&"
import script from "./PaywallSubscriptionNotice.vue?vue&type=script&lang=ts&"
export * from "./PaywallSubscriptionNotice.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallSubscriptionNotice.vue?vue&type=style&index=0&id=2c518246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c518246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c518246', component.options)
    } else {
      api.reload('2c518246', component.options)
    }
    module.hot.accept("./PaywallSubscriptionNotice.vue?vue&type=template&id=2c518246&scoped=true&", function () {
      api.rerender('2c518246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/PaywallSubscriptionNotice.vue"
export default component.exports